import { FC } from 'react'
import ButtonProps from './Button.interface'
import styles from './Button.module.scss'

const Button: FC<ButtonProps> = ({
  variant,
  label,
  onClick,
  disabled,
  className,
}) => (
  <div className={`${className}`}>
    <button
      className={`${styles.root} ${styles[variant]}`}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  </div>
)

export default Button
